import React, { FC, useContext } from 'react';

import { SettingsBlock, SettingsFrame } from 'components';
import { LocalizationContext } from 'localization';

import { PrintGoodsReport, PrintReport, Refund } from './components';

export const Tour: FC = () => {
  const { t } = useContext(LocalizationContext);

  return (
    <>
      <SettingsBlock title={t('settings.billing.work.title')}>
        <SettingsFrame>
          <Refund />
        </SettingsFrame>

        <SettingsFrame>
          <PrintReport />
        </SettingsFrame>

        <SettingsFrame>
          <PrintGoodsReport />
        </SettingsFrame>
      </SettingsBlock>
    </>
  );
};
